// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

export const fromPairs = (
  iterable: Iterable<[string, any]>,
): {[string]: any} => [...iterable].reduce((acc, [key, val]) => {
  acc[key] = val;
  return acc;
}, {});
